import { render, staticRenderFns } from "./enrollment-tabs.vue?vue&type=template&id=543db392&scoped=true&"
import script from "./enrollment-tabs.ts?vue&type=script&lang=ts&"
export * from "./enrollment-tabs.ts?vue&type=script&lang=ts&"
import style0 from "./enrollment-tabs.scss?vue&type=style&index=0&id=543db392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543db392",
  null
  
)

export default component.exports